import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const categoryImages = {
  kr: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20artistic%20style%20illustration%2C%20warm%20romantic%20atmosphere%2C%20soft%20pastel%20colors%2C%20dreamy%20Korean%20webtoon%20aesthetic%2C%20gentle%20lighting%2C%20abstract%20decorative%20elements%2C%20clean%20composition&width=600&height=400&seq=cat-kr-bg&orientation=landscape',
  jp: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20artistic%20style%2C%20dynamic%20action%20energy%2C%20vibrant%20warm%20colors%2C%20modern%20shonen%20aesthetic%2C%20speed%20lines%20and%20comic%20effects%2C%20clean%20composition%2C%20professional%20illustration&width=600&height=400&seq=cat-jp-bg&orientation=landscape',
  cn: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20artistic%20style%2C%20traditional%20ink%20wash%20painting%20blend%2C%20elegant%20ancient%20Chinese%20aesthetic%2C%20warm%20golden%20and%20coral%20tones%2C%20mystical%20atmosphere%2C%20clean%20composition%2C%20professional%20illustration&width=600&height=400&seq=cat-cn-bg&orientation=landscape',
};

const categoryDescs = {
  kr: '热门韩漫持续更新，画风精美',
  jp: '经典日漫热血回归，剧情炸裂',
  cn: '精品国漫崛起之作，国风新潮',
};

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            探索漫画世界
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            三大漫画分类，总有一款适合你。点击进入你喜欢的漫画世界。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-xl overflow-hidden h-56 md:h-64"
            >
              <img
                src={categoryImages[cat.slug as keyof typeof categoryImages]}
                alt={`${cat.label}专区`}
                title={`漫蛙漫画 - ${cat.label}专区`}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                    <i className={`${cat.icon} text-sm`} />
                  </span>
                  <h3 className="text-lg font-heading font-bold text-white">{cat.label}</h3>
                </div>
                <p className="text-sm text-white/70">
                  {categoryDescs[cat.slug as keyof typeof categoryDescs]}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}